'use client'

import React from 'react'
import styles from './styles.module.scss'
import TrashSvg from '@/src/assets/svgs/collection/trash.svg'

interface Props {
    remove: () => void
}

export default function RemoveCashback({ remove }: Props) {
    return (
        <div className={styles.removeCashbackArea} onClick={remove}><TrashSvg className={styles.removeCashback} /> Remover cashback</div>
    )
}